module.exports = __webpack_public_path__ + "img/icon-home-notice-empty.6f35ad7d.svg";